import {Box} from '@mui/material';
import type {Course} from '@jobseeker/common-core/types';

const CourseMetadata = ({
  course,
  isDeviceLarge = false,
}: {
  course: Course;
  isDeviceLarge: boolean;
}) => {
  const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';
  const Dot2 = () => (
    <Box
      component="span"
      sx={{
        width: 4,
        height: 4,
        bgcolor: 'black',
        opacity: 0.5,
        borderRadius: '50%',
        display: 'inline-block',
        mx: '1.75px',
        mr: 1,
        verticalAlign: 'middle',
      }}
    />
  );
  return (
    <Box
      display={isAppIimjobs ? 'flex' : 'inline-block'}
      flexWrap="wrap"
      fontSize={isDeviceLarge ? 14 : 12}
      mt={1}
      ml={isDeviceLarge || !isAppIimjobs ? 0 : 4}
      columnGap={3}
      rowGap={1}
    >
      <Box>
        <Box
          component={!isAppIimjobs && !isDeviceLarge ? 'div' : 'span'}
          color="#888888"
        >
          {isAppIimjobs ? <></> : <Dot2 />}
          Fee:
        </Box>
        <Box component="span" ml={0.25}>
          {course.fee}
        </Box>
      </Box>
      <Box>
        <Box
          component={!isAppIimjobs && !isDeviceLarge ? 'div' : 'span'}
          color="#888888"
        >
          {isAppIimjobs ? <></> : <Dot2 />}
          Experience:
        </Box>
        <Box component="span" ml={0.25}>
          {course.minWorkExp || 0} - {course.maxWorkExp} yrs
        </Box>
      </Box>
      <Box>
        <Box
          component={!isAppIimjobs && !isDeviceLarge ? 'div' : 'span'}
          color="#888888"
        >
          {isAppIimjobs ? <></> : <Dot2 />}
          Duration:
        </Box>
        <Box component="span" ml={0.25}>
          {course.duration}
        </Box>
      </Box>
      <Box>
        <Box
          component={!isAppIimjobs && !isDeviceLarge ? 'div' : 'span'}
          color="#888888"
        >
          {isAppIimjobs ? <></> : <Dot2 />}
          Method:
        </Box>
        <Box component="span" ml={0.25}>
          {course.deliveryMethod}
        </Box>
      </Box>
    </Box>
  );
};

export default CourseMetadata;
